import { Funnel } from 'lucide-react'
import { Button } from '@axilon-apps/libs-ui-shadcn'

interface Props {
  onClick: () => void
  selected: boolean
  isDirty?: boolean
}

const FilterButton = ({ onClick, selected, isDirty = false }: Props) => {
  return (
    <span className="relative inline-flex">
      <Button
        size="icon"
        variant={selected ? 'secondary' : 'outline'}
        onClick={onClick}
        aria-pressed={selected}
      >
        <Funnel />
      </Button>
      {isDirty && (
        <span
          aria-hidden="true"
          className="bg-destructive ring-background absolute -top-0.5 -right-0.5 size-2 rounded-full ring-2"
        />
      )}
    </span>
  )
}

export default FilterButton
